import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
//import config from '../../Config';

const pubClApp = new PublicClientApplication({
    auth: {
        clientId: process.env.REACT_APP_APP_ID as string,
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true
    }
});

// Check if there are already accounts in the browser session
// If so, set the first account as the active account
const accounts = pubClApp.getAllAccounts();
if (accounts && accounts.length > 0) {
    pubClApp.setActiveAccount(accounts[0]);
}

pubClApp.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        //logger.info("Got Payload", event);
        // Set the active account - this simplifies token acquisition
        const authResult = event.payload as AuthenticationResult;
        pubClApp.setActiveAccount(authResult.account);
    }
});
  
export default pubClApp;
